export default __webpack_public_path__ + "static/media/start_market_test.f26b26a1.png";